import { Breadcrumb, Layout } from "antd";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { DefaultAdminPage, DefaultUserPage, FormatUserName } from "../../../config";
import { useAlerts } from "../../../contexts/AlertContext";

const { Header } = Layout;

const findRoutes = {
  admin: DefaultAdminPage,
  user: DefaultUserPage,
};

export default function HeaderView({ user, setData, location, toggleSidebar }) {
  const [currentTime, setCurrentTime] = useState("");
  const navigate = useNavigate();

  // Get unread count from context
  const { unreadCount } = useAlerts();

  useEffect(() => {
    const updateTime = () => {
      const date = new Date();
      const formattedDate = `${String(date.getDate()).padStart(2, "0")}/${String(
          date.getMonth() + 1
      ).padStart(2, "0")}/${date.getFullYear()} ${String(
          date.getHours()
      ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")} (IST)`;
      setCurrentTime(formattedDate);
    };

    updateTime(); // Initial call
    const intervalId = setInterval(updateTime, 1000); // Update every second

    return () => clearInterval(intervalId); // Cleanup interval on unmount
  }, []);

  return (
      <div id="kt_app_header" className="app-header">
        {/*begin::Header container*/}
        <div className="app-container container-fluid d-flex align-items-stretch flex-stack" id="kt_app_header_container">
          {/*begin::Sidebar toggle*/}
          <div className="d-flex align-items-center d-block d-lg-none ms-n3" title="Show sidebar menu">
            {/*begin::Sidebar mobile toggle*/}
            <div className="d-flex align-items-center d-lg-none ms-n3 me-1 me-md-2" title="Show sidebar menu">
              <div onClick={toggleSidebar} className="btn btn-icon btn-active-color-primary w-35px h-35px" id="kt_app_sidebar_mobile_toggle">
                <i className="ki-duotone ki-abstract-14 fs-2 fs-md-1">
                  <span className="path1" />
                  <span className="path2" />
                </i>
              </div>
            </div>
            {/*end::Sidebar mobile toggle*/}
            {/*begin::Logo image*/}
            <a href="index.html">
              <h3 className="mb-0 text-danger fs-2">Dashboard</h3>
              {/* <img alt="Logo" src="assets/media/logo_icon.png" class="h-30px" /> */}
            </a>
            {/*end::Logo image*/}
          </div>
          {/*end::Sidebar toggle*/}
          {/*begin::Navbar*/}
          <div className="app-navbar flex-lg-grow-1" id="kt_app_header_navbar">
            <div className="app-navbar-item me-1 me-md-3 ">
              <Breadcrumb
                  separator={"-"}
                  items={[
                    {
                      title: "Home",
                    },
                    ...location?.pathname
                        ?.split("/")
                        ?.filter((d) => d)
                        ?.map((d) => ({
                          title: FormatUserName(d),
                        })),
                  ]}
              />
            </div>
            <div className="app-navbar-item d-flex align-items-stretch flex-lg-grow-1 ">
            </div>
            <div className="app-navbar-item ms-1 ms-md-3 d-none d-lg-flex">
              <div
                  className="d-flex align-items-center px-4 py-2 rounded-pill shadow-sm bg-light"
                  style={{ backgroundColor: "#fff5f5", border: "1px solid #f45b68", gap: 10 }}
              >
                <div
                    className="d-flex justify-content-center align-items-center rounded-circle"
                    style={{
                      width: 30,
                      height: 30,
                      backgroundColor: "#f45b68",
                    }}
                >
                  <i className="ki-outline ki-time fs-5 text-white" />
                </div>
                <span
                    className="fw-semibold text-danger fs-6"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                >
                {currentTime}
              </span>
              </div>
            </div>
            {/*begin::Chat*/}
            <div className="app-navbar-item ms-1 ms-md-3">
              {/*begin::Menu wrapper*/}
              <Link to="/alerts">
                <div
                    className="btn btn-icon btn-custom btn-color-gray-600 btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px position-relative"
                    id="kt_drawer_chat_toggle"
                >
                  <i className="ki-outline ki-notification-on fs-1" />
                  {/* Dynamic unread count badge */}
                  {unreadCount > 0 && (
                      <span className="position-absolute top-0 start-100 translate-middle badge badge-circle badge-danger w-15px h-15px ms-n4 mt-3">
                    {unreadCount > 99 ? '99+' : unreadCount}
                  </span>
                  )}
                </div>
              </Link>
              {/*end::Menu wrapper*/}
            </div>
            {/*end::Chat*/}
            <div className="app-navbar-item ms-1 ms-md-5">
              {user?.admin && (
                  <button
                      onClick={() => {
                        setData(user?.admin);
                        console.log(findRoutes?.[user?.admin?.loginType])
                        navigate(findRoutes?.[user?.admin?.loginType]);
                      }}
                      className="btn btn-icon btn-danger btn-outline btn-circle w-40px h-40px position-relative border-0"
                  >
                    <i className="ki-outline ki-arrow-left fs-1 " />
                  </button>
              )}
            </div>
          </div>
          {/*end::Navbar*/}
          {/*begin::Separator*/}
          <div className="app-navbar-separator separator d-none d-lg-flex" />
          {/*end::Separator*/}
        </div>
        {/*end::Header container*/}
      </div>
  );
}